var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4118 16.3398H27.8431C27.5183 16.3398 27.2549 16.6032 27.2549 16.9281C27.2549 20.9285 24.0004 24.183 20 24.183C15.9996 24.183 12.7451 20.9285 12.7451 16.9281C12.7451 16.6032 12.4817 16.3398 12.1569 16.3398H10.5882C10.2634 16.3398 10 16.6032 10 16.9281V27.9085C10 28.2328 10.263 28.4967 10.5882 28.4967C10.5922 28.4967 20.0603 28.4736 29.4132 28.4508C29.7375 28.45 30 28.1869 30 27.8626V16.9281C30 16.6032 29.7366 16.3398 29.4118 16.3398Z",
    fill: "#27A376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9621 13.2196C11.5463 13.2998 11.2311 13.6663 11.2311 14.1051C11.2311 14.6025 11.6357 15.0071 12.1331 15.0071C12.572 15.0071 12.9384 14.692 13.0186 14.2761L14.5517 15.8093C14.2572 15.958 14.0546 16.2631 14.0546 16.6149C14.0546 17.1123 14.4592 17.5169 14.9566 17.5169C15.3084 17.5169 15.6136 17.3143 15.7622 17.0198L16.5798 17.8375C16.8096 18.0672 17.182 18.0672 17.4117 17.8375C17.6415 17.6078 17.6415 17.2353 17.4117 17.0056L12.0784 11.6723C11.8487 11.4426 11.4762 11.4426 11.2465 11.6723C11.0168 11.902 11.0168 12.2744 11.2465 12.5041L11.9621 13.2196Z",
    fill: "#27A376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkating);
export default __webpack_public_path__ + "static/media/skating.73b505a0b58f73b0c9683759e80b09a8.svg";
export { ForwardRef as ReactComponent };